import React from 'react';
import Modal from 'components/UI/Modal';
import Loading from 'components/UI/Loading'
import { alert } from 'util/alert';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { ADD_CREDIT, CHARGE, REFUND, REFUND_CREDIT } from "./index";
import { DATE_FORMAT } from 'components/UI/Form/constants';
import StudentModalHeader from 'components/UI/StudentModalHeader';
import { confirmable } from 'react-confirm';
import locale from './locale'
import isEmpty from 'lodash/isEmpty'
import scanImg from './assets/scan.png';
import moment from 'moment'

import snapScan from 'controllers/payment/snapScan';
import checkSnapScan from 'controllers/payment/checkSnapScan';
import getStudentCreditInfo from 'controllers/student/getStudentCreditInfo';
import updateStudentTrade from 'controllers/student/updateStudentTrade';

export const MIN_INTERVAL_FOR_LEGIT_INPUT = 200;
export const CHECK_PAYMENT_RESULT_INTERVAL = 5; // seconds

class ModalBody extends React.Component {

  constructor(props){
    super(props)

    let {student, paymentType} = this.props;
    const DEFAULT_EMPTY_FORM = {
      amount_of_money: 0,
      email_recipient: this.props.student.email,
      send_email_or_not: false,
      trade_date: moment().format(DATE_FORMAT),
    }

    this.state = {
      step: 'payment_info',
      studentCreditInfo: {},
      currentClass: {},
      disabledBtn: false,
      formData: {
        [CHARGE]: DEFAULT_EMPTY_FORM,
        [ADD_CREDIT]: DEFAULT_EMPTY_FORM,
        [REFUND]: DEFAULT_EMPTY_FORM,
        [REFUND_CREDIT]: DEFAULT_EMPTY_FORM,
      },
    }

    if (paymentType == REFUND) {
      this.state.paymentType = REFUND;
    } else if (paymentType == REFUND_CREDIT){
      this.state.paymentType = REFUND_CREDIT;
    } else {
      if (student.classList && student.classList.length > 0) {
        this.state.paymentType = CHARGE;
      } else {
        this.state.paymentType = ADD_CREDIT;
      }
    }

    this.isPaymentWithBarcodeScan = this.isPaymentWithBarcodeScan.bind(this)
    this.changePaymentType = this.changePaymentType.bind(this)
    this.onFormChange = this.onFormChange.bind(this)
    this.checkClassType = this.checkClassType.bind(this)
    this.renderFooterButtons = this.renderFooterButtons.bind(this)
    this.recordScanner = this.recordScanner.bind(this)
    this.submitBarcode = this.submitBarcode.bind(this)
    this.startCheckingPaymentResult = this.startCheckingPaymentResult.bind(this)

    this.legitInput = '';
    this.legitInput = '';
    this.tradeID;
  }

  componentWillMount() {
    let { student } = this.props;

    getStudentCreditInfo(student.id)
    .then(({ data })=>{
      this.setState({
        studentCreditInfo: data,
      });
    })
    .catch((err)=>{
      console.error(err);
    });
  }

  renderFooterButtons() {
    let {paymentType, step, disabledBtn, currentClass, formData} = this.state;
    let {student, user_id, proceed} = this.props;
    let discountPrice = (formData.charge.discount_amount * 100) || 0
    let lessonQuantity = formData.charge.lesson_quantity || 1
    let price = currentClass.feeType == 0 ? currentClass.classTotalFee : currentClass.unitPrice



    let newData;
    if(paymentType == CHARGE){

      let amountPayable
      if(formData.charge.amount_payable){
        amountPayable = formData.charge.amount_payable * 100;
      }

      newData = {
        ...this.state.formData.charge,
        operator_id: user_id,
        trade_date: moment(formData.charge.trade_data).format('YYYY-MM-DD'),
        trade_type: 'charge',
        discount_amount: discountPrice / 100,
        amount_payable: amountPayable ? amountPayable/100 : (price * 100 * lessonQuantity) / 100,
        amount_of_money: amountPayable ? (amountPayable - discountPrice) / 100 : ((price * 100 * lessonQuantity) - discountPrice) / 100,
        end_date: formData.charge.end_date ? moment(formData.charge.end_date).format('YYYY-MM-DD') : undefined
      }
    }

    if(paymentType == ADD_CREDIT){
      newData = {
        ...this.state.formData.add_credit,
        operator_id: user_id,
        trade_date: moment(formData.add_credit.trade_data).format('YYYY-MM-DD'),
        trade_type: 'charge',
      }
    }

    if(paymentType == REFUND){
      newData = {
        ...this.state.formData.refund,
        operator_id: user_id,
        trade_date: moment(formData.refund.trade_data).format('YYYY-MM-DD'),
        trade_type: 'refund',
        end_date: formData.refund.end_date ? moment(formData.refund.end_date).format('YYYY-MM-DD') : undefined
      }
    }

    if(paymentType == REFUND_CREDIT){
      newData = {
        ...this.state.formData.refund_credit,
        operator_id: user_id,
        trade_date: moment(formData.refund_credit.trade_data).format('YYYY-MM-DD'),
        trade_type: 'refund',
      }
    }

    this.newData = newData;

    if (step === 'payment_info') {
      if ((paymentType !== REFUND || paymentType !== REFUND_CREDIT) && this.isPaymentWithBarcodeScan()) {
        return [
          {
            title: __('Proceed to payment', locale),
            className: 'btn btn-primary pull-right',
            onClick: ()=>{

              this.setState({disabledBtn: true})
              updateStudentTrade(student.id, newData)
              .then((res) => {
                this.tradeId = res.data.trade_id
                window.addEventListener('keypress', this.recordScanner)
                this.setState({step: 'scan_barcode'});
                // proceed({ success: true });
              })

            },
            isDisabled: ()=>{
              return disabledBtn;
            }
          },
        ];
      } else {
        return [
          {
            title: __('Confirm', 'UI.confirm'),
            className: 'btn btn-primary pull-right',
            onClick: ()=>{
              const validateResultRight = this.validateRight();
              const validateResultLeft = this.validateLeft();
              if (!validateResultRight.ok || !validateResultLeft.ok) {
                return;
              }
              this.setState({disabledBtn: true})
              updateStudentTrade(student.id, newData)
              .then((res) => {
                proceed({ success: true });
              })
            },
            isDisabled: ()=>{
              return disabledBtn;
            }
          },
        ]
      }
    }
  }

  isPaymentWithBarcodeScan() {
    let {paymentType, formData} = this.state;
    const form = formData[paymentType];

    return ['wechat_barcode_pay', 'ali_barcode_pay'].indexOf(form.payment_method) > -1;
  }

  changePaymentType(paymentType) {
    this.setState({paymentType});
  }

  onFormChange(formData) {
    const {paymentType} = this.state;

    if (formData.class_id) {
      this.checkClassType(formData.class_id);
    }

    this.setState({
      formData: {
        ...this.state.formData,
        [paymentType]: formData,
      }
    });
  }

  checkClassType(class_id) {
    const { student } = this.props;
    if (student.classList) {
      student.classList.map((cls)=>{
        if (cls.classID == class_id) {
          if(!cls.hasOwnProperty('paidTotalQuantity')){
            let newData = {
              ...cls,
              paidTotalQuantity: student.paidTotalQuantity,
              usedTotalQuantity: student.usedTotalQuantity,
              classTotalFee: cls.total_price,
              unitPrice: cls.unit_price,
            }
            this.setState({currentClass: newData});
          } else {
            this.setState({currentClass: cls});

          }
        }
      });
    }
  }

  recordScanner(e) {
    e.preventDefault();

    clearTimeout(this.recordScannerTimeout);

    if (e.charCode === 13) {
      this.submitBarcode(this.legitInput);
      return;
    }
    this.legitInput += e.key;

    this.recordScannerTimeout = setTimeout(()=>{
      this.submitBarcode(this.legitInput);
    }, MIN_INTERVAL_FOR_LEGIT_INPUT)
  }

  submitBarcode(code) {
    this.legitInput = '';
    window.removeEventListener('keypress', this.recordScanner)

    let sendEmail = this.newData.send_email_or_not ? true : false
    let emailRecipient = this.newData.send_email_or_not ? this.newData.email_recipient : undefined

    snapScan(this.tradeId, {auth_code: code, send_email_or_not: sendEmail, email_recipient: emailRecipient})
    .then((res) => {
      if (res.result === 'failure') {
        if (res.reason === 'the school has not set Wechat pay or Alipay') {
          alert.fail(__("WeChat Pay and Alipay are not set up for this school. Please contact us to create an account.", locale))
          this.setState({step: "payment_info", disabledBtn: false});
          return;
        } else {
          alert.fail(__("", locale))
          this.setState({step: "payment_info", disabledBtn: false});
          return;
        }
      }

      if (res.creation_result === 'success' && res.payment_result === 'success') {
        this.setState({step: "payment_successful"});
      } else if (res.creation_result === 'success' && res.payment_result === 'to be queried') {
        this.startCheckingPaymentResult(this.tradeId);
      } else {
        alert.fail(__("", locale))
        this.setState({step: "payment_info", disabledBtn: false});
      }
    })
  }

  startCheckingPaymentResult(tradeID) {
    let totalTry = 0;

    this.setState({step: 'processing'});

    setTimeout(()=>{
      this.callCheckSnapScan(tradeID, ()=>{

      let interval = setInterval(()=>{
        this.callCheckSnapScan(tradeID, ()=>{
          totalTry++;

          if (totalTry >= 5) {
            clearInterval(interval);
            alert.fail(__("Payment Request Timeout", locale))
            this.setState({step: "payment_info", disabledBtn: false});
          }
         });

        }, CHECK_PAYMENT_RESULT_INTERVAL * 1000);
      }, CHECK_PAYMENT_RESULT_INTERVAL * 1000);
    });
  }

  callCheckSnapScan(tradeID, callAgain) {
    checkSnapScan(tradeID)
    .then((res)=>{
      const {payment_result, result} = res;

      if (payment_result === 'success') {
        this.setState({step: "payment_successful",});
      } else if (payment_result === 'to be queried') {
        callAgain();
      }

    });
  }

	render() {
		let {show, proceed, dismiss, student} = this.props;
    let {currentClass, paymentType, step} = this.state;
    let {currency, balance} = this.state.studentCreditInfo;

    if(isEmpty(this.state.studentCreditInfo)){
      return (<div/>)
    }

		return (
      <Modal
        isShowingModal={show}
        onCloseModalClick={dismiss}
        className='new-payment-modal'

        fixedWidth={620}
        contentHeight={528}

        hasHeader={true}
        headerType="bold"
        headerTitle=""

        headerCustomContent={<StudentModalHeader name={student.name} gender={student.gender} profileThumbnail={student.profilePhotoThumbnail2x}/>}

        hasFooter={step === 'payment_info'}
        footerType='grey' // grey, transparent, bold
        footerButtons={this.renderFooterButtons(this.state.formData)}
        footerCustomContent={
          <div className='price-on-modal'>{__('Account Balance: ', 'classdetail')} {balance} {currency.toUpperCase()}</div>
        }
      >
        <div>
          {step == 'payment_info' && <ModalContent
            student={student}
            studentCreditInfo={this.state.studentCreditInfo}
            paymentType={paymentType}
            changePaymentType={this.changePaymentType}
            onFormChange={this.onFormChange}
            currentClass={currentClass}
            getValidationRefRight={(fn)=>{
              this.validateRight = fn;
            }}
            getValidationRefLeft={(fn)=>{
              this.validateLeft = fn;
            }}
          />}
          {step == 'scan_barcode' && <div className='scan-msg'>
            <h1>
              {__("Scan Payment QR Code", locale)}
            </h1>
            <p>
              {__("Please do not close this window during scanning", locale)}
            </p>
            <div className='scan-image-wrapper'>
              <img src={scanImg} />
              <div className='text-center circle-container'>
                <div className='circle1'></div>
                <div className='circle2'></div>
                <div className='circle3'></div>
                <div className='circle4'></div>
                <div className='circle5'></div>
              </div>
            </div>
          </div>}
          { step === 'processing' &&
            <div className='processing-container'>
              <Loading />
              <p>{__('Processing...', locale)}</p>
            </div>
          }
          { step === 'payment_successful' &&
            <div className='scan-msg'>
              <i className='fa icon-ok'></i>
              <h2>{__('Payment Successful', locale)}</h2>
              <a className='btn btn-primary' onClick={()=>{
                  proceed({ success: true });
                }}>{__('Confirm', locale)}
              </a>
            </div>
          }
        </div>
      </Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/template/Modals/NewPayment/ModalBody.js